export default {
      MyOrdersHistory: 'Closed Order|Orders History',
      MyOrdersHistory_no_body: 'Closed Order',
};
